// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.inspectionSubjectFlag-popblinking {\n  -webkit-animation:inspectionSubjectFlag-popblink 3s ease-in-out infinite alternate;\n  animation:inspectionSubjectFlag-popblink 3s ease-in-out infinite alternate;\n}\n@-webkit-keyframes inspectionSubjectFlag-popblink {\n0% { opacity:0\n}\n100% { opacity:1\n}\n}\n@keyframes inspectionSubjectFlag-popblink {\n0% { opacity:0\n}\n100% { opacity:1\n}\n}\n", ""]);
// Exports
module.exports = exports;
